var _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5,
    cy: 25,
    rx: 8.5,
    ry: 2,
    fill: "url(#paint0_radial_386_8829)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5397,
    cy: 24.9678,
    rx: 2.485,
    ry: 0.342761,
    fill: "url(#paint1_radial_386_8829)",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42246 6.36621L10.6694 0.601233L13.9164 6.36621L10.6694 12.0854L7.42246 6.36621Z",
    fill: "#D8D8D8",
    stroke: "#E4E4E4",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3508 6.62635L20.8837 6.57996L17.5779 12.3252L11.084 12.3486L14.3508 6.62635Z",
    fill: "#D8D8D8",
    stroke: "#E4E4E4",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98803 6.6283L0.455146 6.58191L3.76101 12.3271L10.2548 12.3506L6.98803 6.6283Z",
    fill: "#D8D8D8",
    stroke: "#E4E4E4",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9208 18.8096L10.6738 24.5745L7.4269 18.8096L10.6738 13.0904L13.9208 18.8096Z",
    fill: "#D8D8D8",
    stroke: "#E4E4E4",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99292 18.5494L0.46003 18.5958L3.7659 12.8506L10.2597 12.8272L6.99292 18.5494Z",
    fill: "#D8D8D8",
    stroke: "#E4E4E4",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3442 18.5626L20.8788 18.5842L17.5931 12.8376L11.0975 12.8388L14.3442 18.5626Z",
    fill: "#D8D8D8",
    stroke: "#E4E4E4",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_386_8829",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5 25) rotate(90) scale(2 8.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_386_8829",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5397 24.9678) rotate(90) scale(0.342761 2.485)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsInactive);
export default __webpack_public_path__ + "static/media/stars-inactive.0bb3d466f8017cb7a1a87b17e9a4d8ea.svg";
export { ForwardRef as ReactComponent };